/**
 * Anatomy photo records returned by the legacy `/dashboard/annotation-photo`
 * endpoint carry a `subType` like "MALE_FRONT" / "FEMALE_BACK" — there is no
 * separate `type` field. The thumbnail strip needs to filter rows by gender
 * (the `activeType` toggle), so we compare the prefix before the underscore.
 *
 * Returns true if `row.subType` starts with `${gender}_` (e.g. row
 * `{subType:"MALE_FRONT"}` matches gender `"MALE"`).
 */
export function matchesGender(row, gender) {
  if (!row || !row.subType || !gender) return false;
  const prefix = row.subType.split("_")[0];
  return prefix === gender;
}
